import { jsxs as g, jsx as x } from "react/jsx-runtime";
import { c as Y } from "react/compiler-runtime";
import l from "moment-timezone";
const h = {
  label: {
    fontSize: "10px",
    color: "#5A5A5A",
    display: "flex"
  },
  input: {
    padding: "4px 8px",
    fontSize: "14px",
    cursor: "pointer",
    minWidth: "200px",
    borderRadius: "8px",
    border: "1px solid #EFEFEF",
    backgroundColor: "#F7F7F7",
    color: "#5A5A5A",
    fontWeight: 500,
    lineHeight: "14px",
    height: "32px"
  }
};
function s(t) {
  const e = Y(24), i = t.type ?? "datetime-local", n = i === "date" ? "YYYY-MM-DD" : i === "time" ? "HH:mm" : "YYYY-MM-DDTHH:mm", u = t.label ?? "Time";
  let a;
  e[0] !== u ? (a = /* @__PURE__ */ x("label", { children: /* @__PURE__ */ x("span", { style: h.label, children: u }) }), e[0] = u, e[1] = a) : a = e[1];
  let o;
  e[2] !== n || e[3] !== t.value ? (o = l(t.value).format(n), e[2] = n, e[3] = t.value, e[4] = o) : o = e[4];
  let m;
  e[5] !== n || e[6] !== t.max ? (m = t.max ? l(t.max).format(n) : void 0, e[5] = n, e[6] = t.max, e[7] = m) : m = e[7];
  let f;
  e[8] !== n || e[9] !== t.min ? (f = t.min ? l(t.min).format(n) : void 0, e[8] = n, e[9] = t.min, e[10] = f) : f = e[10];
  let d;
  e[11] !== t || e[12] !== i ? (d = (b) => {
    const v = i === "date" ? l(b.target.value, "YYYY-MM-DD").toDate() : l(b.target.value).toDate();
    t.onChange(v);
  }, e[11] = t, e[12] = i, e[13] = d) : d = e[13];
  let r;
  e[14] !== t.disabled || e[15] !== o || e[16] !== m || e[17] !== f || e[18] !== d || e[19] !== i ? (r = /* @__PURE__ */ x("input", { type: i, style: h.input, value: o, max: m, min: f, disabled: t.disabled, onChange: d }), e[14] = t.disabled, e[15] = o, e[16] = m, e[17] = f, e[18] = d, e[19] = i, e[20] = r) : r = e[20];
  let c;
  return e[21] !== a || e[22] !== r ? (c = /* @__PURE__ */ g("div", { children: [
    a,
    r
  ] }), e[21] = a, e[22] = r, e[23] = c) : c = e[23], c;
}
function F({
  startTime: t,
  endTime: e,
  onChange: i,
  min: n,
  max: u = l().toDate()
}) {
  return /* @__PURE__ */ g("div", { style: {
    display: "flex"
  }, children: [
    /* @__PURE__ */ x(s, { label: "From", value: t, min: n, max: e, disabled: l(t).isSameOrAfter(l(e)), onChange: (a) => {
      l(a).isSameOrAfter(l(e)) || i(a, e);
    } }),
    /* @__PURE__ */ x(s, { label: "To", value: e, min: t, max: u, disabled: l(e).isSameOrBefore(l(t)), onChange: (a) => {
      l(a).isSameOrBefore(l(t)) || i(t, a);
    } })
  ] });
}
export {
  F as DateTimePicker,
  s as TimeDateInput,
  s as default
};
